export interface LeadPayload {
  name: string;
  email: string;
  phone: string;
  company: string;
  topic: string;
  teamSize?: string;
  message?: string;
}

export async function submitLead(
  payload: LeadPayload,
): Promise<{ ok: boolean; error?: string }> {
  const url = import.meta.env.VITE_GOOGLE_SCRIPT_URL;

  const body = JSON.stringify({
    source: "innovriddhi-landing",
    timestamp: new Date().toISOString(),
    // Field aliases matching standard Google Apps Script column mappings
    contactName: payload.name,
    companyName: payload.company,
    companySize: payload.teamSize,
    industry: payload.topic,
    ...payload,
  });

  // Local development fallback when no Apps Script URL is set
  if (!url) {
    console.info(
      "[Dev] Lead captured locally (VITE_GOOGLE_SCRIPT_URL not configured):",
      payload,
    );
    // Simulate brief network latency for realistic UX
    await new Promise((resolve) => setTimeout(resolve, 600));
    return { ok: true };
  }

  try {
    // Note: Google Apps Script web apps require text/plain to avoid CORS preflight failures
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain;charset=utf-8",
      },
      body,
    });

    if (response.ok || response.status === 302 || response.type === "opaque") {
      return { ok: true };
    }

    return {
      ok: false,
      error: `Submission returned status ${response.status}`,
    };
  } catch (err) {
    console.error("Lead submission error:", err);
    return {
      ok: false,
      error:
        err instanceof Error
          ? err.message
          : "Network error during lead submission",
    };
  }
}
